import { ReactNode } from 'react'
import classNames from 'classnames'
import styles from './HeaderContainer.module.scss'

export type HeaderContainerProps = {
  children: ReactNode
  className?: string
}
export default function HeaderContainer(
  props: HeaderContainerProps
): JSX.Element {
  const { children, className } = props
  return (
    <div className={classNames(styles.container, className)}>{children}</div>
  )
}
